import { ReactNode } from "react"
import {
  Block,
  FlexGrid,
  FlexGridItem,
  HeadingSmall,
} from "@mezo-org/mezo-clay"

type HomepageMainSectionAssetsItemProps = {
  header: ReactNode
  value: ReactNode
  label: ReactNode
  buttons: ReactNode[]
}

export default function HomepageMainSectionAssetsItem({
  header,
  value,
  label,
  buttons,
}: HomepageMainSectionAssetsItemProps) {
  return (
    <Block
      backgroundColor="white"
      padding="16px"
      overrides={{ Block: { style: () => ({ borderRadius: "12px" }) } }}
    >
      <Block marginBottom="32px" height="24px">
        {header}
      </Block>
      <HeadingSmall>{value}</HeadingSmall>
      <Block marginBottom="20px" height="24px">
        {label}
      </Block>
      <FlexGrid
        flexGridColumnCount={buttons.length}
        flexGridColumnGap="scale300"
        height="36px"
      >
        {buttons.map((button, index) => (
          <FlexGridItem
            // eslint-disable-next-line react/no-array-index-key
            key={`button-${index}`}
            overrides={{
              Block: {
                style: () => ({ width: "auto", flexGrow: 0 }),
              },
            }}
          >
            {button}
          </FlexGridItem>
        ))}
      </FlexGrid>
    </Block>
  )
}
